import { Link } from 'react-router-dom';
import MetaHead from '../components/MetaHead';

export default function NotFoundPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center space-y-8">
      <MetaHead 
        title="404 - Siden blev ikke fundet - Din Privat Psykolog" 
        description="Siden du leder efter findes desværre ikke på Din Privat Psykologs hjemmeside."
      />

      <div className="space-y-4">
        <div className="w-20 h-20 rounded-full bg-[#EBF2EE] text-[#5f7365] flex items-center justify-center mx-auto text-3xl shadow-2xs">
          <i className="fa-regular fa-compass" aria-hidden="true" />
        </div>
        <p className="text-xs font-mono uppercase tracking-widest text-[#52685B] font-semibold">
          Fejl 404
        </p>
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Siden blev ikke fundet
        </h1>
        <p className="text-base text-[#465A4F] max-w-lg mx-auto leading-relaxed">
          Siden du leder efter findes desværre ikke eller kan være blevet flyttet. Du kan nemt vende tilbage til forsiden eller benytte menuen.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
        <Link
          to="/"
          className="px-6 py-3 bg-[#5f7365] hover:bg-[#4e6053] text-white font-semibold rounded-none text-sm transition-all duration-200 hover:-translate-y-1 inline-flex items-center gap-2 shadow-xs"
        >
          <i className="fa-regular fa-house" aria-hidden="true" />
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="px-6 py-3 bg-white hover:bg-[#FAF8F3] text-[#5f7365] font-semibold rounded-none border border-[#D5CEBF] text-sm transition-all duration-200 hover:-translate-y-1 inline-flex items-center gap-2"
        >
          <i className="fa-regular fa-envelope" aria-hidden="true" />
          Kontakt Marie
        </Link>
      </div>
    </div>
  );
}
